// extracted by mini-css-extract-plugin
export default {"activeIcon":"xlsvrQO84YXCQw74RhWA","deactivateIcon":"_KJuAeOEtAWta65aBxjQ"};